import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  container: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  containerView: {
    position: "relative",
    paddingBottom: "20px",
  },
  title: {
    fontSize: "20px",
    fontFamily: "Manrope",
    fontWeight: 600,
    lineHeight: "24px",
    color: "#465869",
    marginBottom: "10px",
  },
  rowTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "27px",
    color: getBrandCustom("primaryColor", "#308CDB"),
  },
  icon: {
    cursor: "pointer",
  },
  line: {
    height: "1px",
    width: "100%",
    backgroundColor: "#CCDEEE",
    marginBottom: "20px",
  },
  grid: {
    padding: "20px 0",
  },
  rowGrid: {
    padding: "0 0 20px 0",
  },
  rowGridMulti: {
    padding: "0 0 20px 0",
    width: "200px",
    marginRight: "15px",
  },
  containerTaskDates: {
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
    flexDirection: "row",
    flexWrap: "nowrap",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  iconButton: {
    marginRight: "5px",
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  sectionWithoutDivisor: {
    "& label": {
      marginBottom: 0,
    },
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  textInvitation: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: "#308CDB",
  },
  textDisabled: {
    color: "rgb(102, 112, 133) !important",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  gap16px: {
    gap: "16px",
  },
}));

export default styles;
